<template>
  <div v-if="this.type === 'line'" class="ma-0 pa-0">
    <v-progress-linear
      ma-0
      pa-0
      style="margin: 0 !important"
      :indeterminate="true"
      :color="color"
      height="4"
      v-if="show"
    >
    </v-progress-linear>
  </div>
  <div v-else-if="this.type === 'dialog'">
    <v-dialog v-model="show" v-if="show" hide-overlay persistent width="300">
      <v-card :color="this.color" dark>
        <v-card-text ma-2>
          {{ this.message }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <div v-else>
    <v-layout row justify-center>
      <v-dialog
        transition="false"
        v-model="show"
        persistent
        fullscreen
        content-class="loading-dialog"
      >
        <v-container fill-height>
          <v-layout row justify-center align-center>
            <v-progress-circular
              indeterminate
              :size="60"
              :width="3"
              :color="color"
            ></v-progress-circular>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "progress-bar",
  props: {
    show: {
      type: [Boolean, String],
      required: true,
    },
    color: {
      type: String,
      default: "indigo",
    },
    type: {
      type: String,
      default: "line",
    },
    message: {
      type: String,
      default: "aguarde...",
    },
  },
};
</script>

<style lang="css">
.progress-linear {
  height: 4px;
  left: 0;
  margin: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 999999;
}
.loading-dialog {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
